const SITE_SUFFIX = 'יאמי'

const ROUTE_TITLES = {
  home: 'דף הבית',
  cook: 'תפריט בשלן',
  dish: 'מנה',
  'search-cooks': 'רשימת בשלנים',
  'search-ptype': 'חיפוש',
  'search-cpref': 'חיפוש',
  'search-anysearcg': 'חיפוש',
  contact: 'יצירת קשר',
  quality_standard: 'תקן האיכות',
  about_orders: 'אודות הזמנות',
  about: 'אודות',
  ambassadors: 'שגרירים',
  impact: 'השפעה',
  faq: 'שאלות ותשובות',
  'users-login': 'כניסה',
  'users-register': 'הרשמה',
  'users-settings': 'הגדרות חשבון',
  'orders-checkout': 'קופה',
  'orders-delivery-details': 'פרטי משלוח',
  'orders-payment': 'תשלום',
  'orders-completed': 'הזמנה הושלמה',
  orders: 'הזמנות שלי',
  favorites: 'מועדפים',
  static: 'יאמי',
  'static-pages': 'יאמי',
  media: 'בתקשורת',
  articles: 'מאמרים',
  campaigns: 'קמפיינים',
  giftcard: 'גיפטקארד',
  reut_voucher: 'רעות תקני לי',
  cook_join_payment: 'תשלום דמי הקמה',
  cook_join_payment_completed: 'תשלום דמי הקמה',
  not_found: 'הדף לא נמצא',
  e500: 'שגיאה',
}

const DEFAULT_PAGE_TITLE = 'אנשים מבשלים לאנשים'

export function updateDocumentTitle(route) {
  if (typeof document === 'undefined' || !route?.name) {
    return
  }
  const pageTitle = ROUTE_TITLES[route.name]
  if (pageTitle) {
    document.title = `${pageTitle} | ${SITE_SUFFIX}`
    return
  }
  document.title = `${DEFAULT_PAGE_TITLE} | ${SITE_SUFFIX}`
}
